import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"container mx-auto my-24 px-4\"><div><div class=\"text-2xl font-semibold my-4 text-center\"> Extreme weather is a result of global warming. </div><div class=\"text-sm my-4 max-w-2xl mx-auto text-center text-gray-500\"> Every year, extreme weather causes heat waves that is responsible for over 5 million death of heat-related death worldwide. Extreme climate also leads to drastic loss of agricultural production. It also results in the increase of heat-related death and the spread of infectious insect-borne diseases that results from the increase of mosquito population. </div><div class=\"flex flex-wrap border border-gray-100 shadow-md rounded px-4 py-4 md:divide-x divide-gray-100 my-8\"><div class=\"px-6 py-6 w-full md:flex-1\"><div class=\"text-center font-semibold text-xl\">125 million</div><div class=\"text-center text-sm text-green-800\"> killed from heatwaves </div></div><div class=\"px-6 py-6 w-full md:flex-1\"><div class=\"text-center font-semibold text-xl\">250 million</div><div class=\"text-center text-sm text-green-800\"> suffer from famine </div></div><div class=\"px-6 py-6 w-full md:flex-1\"><div class=\"text-center font-semibold text-xl\">21 %</div><div class=\"text-center text-sm text-green-800\"> decline in crop productivity </div></div><div class=\"px-6 py-6 w-full md:flex-1\"><div class=\"text-center font-semibold text-xl\">320 million</div><div class=\"text-center text-sm text-green-800\"> afflicted by malaria </div></div></div></div></div>", 1)
const _hoisted_2 = { class: "container mx-auto my-24 px-4" }
const _hoisted_3 = { class: "flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_landing_banner = _resolveComponent("landing-banner")!
  const _component_landing_image_link = _resolveComponent("landing-image-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_landing_banner, {
      text: "Every year, millions are killed worldwide because of extreme weather.",
      bg: "/images/gw-ew/banner.webp"
    }),
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createVNode(_component_landing_image_link, {
          to: "/landing/global-warming/extreme-weather",
          text: "Extreme Weather",
          bg: "/images/gw-ew/img-1.webp"
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_landing_image_link, {
          to: "/landing/global-warming/ocean-acidification",
          text: "Ocean Acidification",
          bg: "/images/gw-ew/img-2.webp"
        }),
        _createVNode(_component_landing_image_link, {
          to: "/landing/global-warming/rising-sea-level",
          text: "Rising Sea Level",
          bg: "/images/gw-ew/img-3.webp"
        })
      ])
    ])
  ]))
}